/**
 * Single source of truth for the assistant's greeting/placeholder copy: the
 * drawer's empty-state line, the drawer input placeholder, and the homepage
 * chat-box placeholder all read this constant (product decision — one voice).
 */
export const GLOBAL_AI_ASSISTANT_GREETING = 'Ask about the workforce';
